"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUserSettings = saveUserSettings;
exports.fetchUserSettings = fetchUserSettings;

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _UserSettings = require("FileManagerCore/api/UserSettings");

function saveUserSettings(userId, data) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.SAVE_USER_SETTINGS_ATTEMPTED,
      data: data
    });
    (0, _UserSettings.saveSettings)(userId, data).done();
  };
}

function fetchUserSettings(userId) {
  return function (dispatch) {
    (0, _UserSettings.fetchSettings)(userId).then(function (userSettings) {
      dispatch({
        type: _ActionTypes.default.FETCH_USER_SETTINGS_SUCCEEDED,
        userSettings: userSettings
      });
    });
  };
}